module.exports = __webpack_public_path__ + "static/media/raduno1960.9b687a3f.jpg";